import React from "react";
import { CreateVariantChildFormFormContext } from "./context";

export const useCreateVariantChildFormProvider = () => {
  const context = React.useContext(CreateVariantChildFormFormContext);
  return context;
};
